import { render, staticRenderFns } from "./SettingsCardMailTemplatesOrder.vue?vue&type=template&id=df59fb04&scoped=true"
import script from "./SettingsCardMailTemplatesOrder.vue?vue&type=script&lang=ts"
export * from "./SettingsCardMailTemplatesOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df59fb04",
  null
  
)

export default component.exports